import React, { ReactElement, useState } from "react";
import { Link } from "react-router-dom";
import { ChooseTemplate } from "../../Models/ChooseTemplate";
import { ROOT_PATH } from "../../Config/Constants";
import { DeleteTemplateDocId } from "../../Util/helper";

export default function ChooseTemplateCard({ title, subTitle, link }: ChooseTemplate): ReactElement {
  const [isOpen, setIsOpen] = useState(true);

  const handleToggle = () => setIsOpen(!isOpen);

  return (
    <div className="choose-template-accordion">
      <div className="accordion mb-3" id={`accordion-${link}`}>
        <div className="accordion-item">
          <h2 className="accordion-header" id={`heading-${link}`}>
            <button
              className={`accordion-button ${!isOpen ? "collapsed" : ""}`}
              type="button"
              onClick={handleToggle}
              aria-expanded={isOpen}
              aria-controls={`collapse-${link}`}
            >
              {title}
            </button>
          </h2>
          <Link
            onClick={() => DeleteTemplateDocId(link, true)}
            to={`/${ROOT_PATH}/${link}`}
            id={`collapse-${link}`}
            className={`accordion-collapse collapse ${isOpen ? "show" : ""}`}
            aria-labelledby={`heading-${link}`}
            data-bs-parent={`#accordion-${link}`}
          >
            <div className="accordion-body">
              <p>{subTitle}</p>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
}
